import axios from '@service'
import { SUBMIT_POLICY_UPLOAD_INFO } from './api'
import { HTTP_ERR_SUCCESS } from '@constant/api_status'
import { ERROR_DEFAULT_HTTP_REQUEST_FAIL } from '@constant/error'

/** 提交保单上传信息 */
export default async function submitPolicyUploadInfoService(payload = {}, config = {}) {
    const param = {
        ...SUBMIT_POLICY_UPLOAD_INFO,
        ...config,
        data: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}
